<template>
  <component :is="Resolved" :style="iconStyleObj" v-bind="attrs" aria-hidden="true" />
</template>

<script setup>
import { computed, useAttrs } from 'vue'
import * as SolidIcons from '@heroicons/vue/24/solid'
import * as OutlineIcons from '@heroicons/vue/24/outline'

const attrs = useAttrs()

const props = defineProps({
  name: { type: String, default: null },
  iconStyle: { type: String, default: null },
  color: { type: String, default: null },
  size: { type: [Number, String], default: null },
})

const resolvedName = computed(() => props.name || 'UserCircleIcon')
const resolvedSet = computed(() => (props.iconStyle === 'solid' ? 'solid' : 'outline'))

const Resolved = computed(() => {
  const set = resolvedSet.value === 'solid' ? SolidIcons : OutlineIcons
  return set[resolvedName.value] || OutlineIcons.UserCircleIcon
})

const iconStyleObj = computed(() => {
  const style = {
    flexShrink: 0,
  }
  if (props.size !== null && props.size !== undefined && String(props.size).trim() !== '') {
    const size = typeof props.size === 'number' ? `${props.size}px` : props.size
    style.width = size
    style.height = size
  }
  if (props.color) style.color = props.color
  return style
})
</script>
